import { Plugin } from '@nuxt/types'
import { AnalyticsProvider } from '@alao-frontend/analytics.plugin/core/analytics.provider'
import { trackOspCameraPayload } from '~/utils/osp-camera-tracking'

class LogRocketOspCameraProvider extends AnalyticsProvider {
  private queue: Promise<void> = Promise.resolve()

  constructor () {
    super('logrocket-osp-camera', 'client', false)
  }

  send (event: { payload?: unknown }): void {
    this.queue = this.queue
      .then(() => trackOspCameraPayload(event.payload))
      .catch((e) => {
        console.error('Failed to forward camera telemetry to LogRocket', e)
      })
  }
}

const ospCameraTrackingPlugin: Plugin = ({ app, $config }) => {
  if (!$config.LOGROCKET_IS_ENABLED) {
    return
  }

  try {
    app.$analytics.GTM.register(new LogRocketOspCameraProvider())
  } catch (e) {
    console.error('Failed to register LogRocket camera tracking provider', e)
  }
}

export default ospCameraTrackingPlugin
